import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}ownerProducts/files`;

export interface GetFilesForProductsCommandPayload {
  ownerProductIds: string[];
}

export const getFilesForProductsRequest = ({
  ownerProductIds,
}: GetFilesForProductsCommandPayload): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.POST, json: { ownerProductIds } },
});

async function getFilesForProductsCommand(
  payload: GetFilesForProductsCommandPayload,
): Promise<
  BackResponse<Record<string, unknown[]>> | BackResponseFailure
> {
  try {
    return await executeQuery<BackResponse<Record<string, unknown[]>>>(
      getFilesForProductsRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default getFilesForProductsCommand;
